// extracted by mini-css-extract-plugin
export var alertIcon = "_nw-0";